import React, {Component} from 'react';
import moment from "moment";

class TimerUntilEnd extends Component {

    constructor(props) {
        super(props);
        this.state = {days:0, hours:0, minutes:0, seconds: 0};
        window.startTimer = this.startTimer.bind(this);
        window.stopTimer = this.stopTimer.bind(this);
        this.formatterDate = this.formatterDate.bind(this);
    }

    componentDidMount() {
        this.startTimer();
    }

    startTimer() {
        clearTimeout(window.timerID);
        let endTimeFromLS =window.localStorage.getItem('end_hire');
        let carStatus = window.localStorage.getItem('start_timer');
        if (endTimeFromLS && carStatus === '1') {
            let endTime = moment(endTimeFromLS).valueOf();
            let startTime = moment().valueOf();
            let duration = endTime - startTime;
            if (duration < 0) {
                this.stopTimer();
                return false;
            }
            let seconds = parseInt((duration/1000)%60);
            let minutes = parseInt((duration/(1000*60))%60);
            let hours = parseInt((duration/(1000*60*60))%24);
            let days = parseInt(duration/(1000*60*60*24));
            this.setState({days, hours, minutes, seconds});
            window.timerID = setTimeout(()=>this.startTimer(), 1000);
        } else
            this.stopTimer();
    }

    stopTimer() {
        clearTimeout(window.timerID);
        this.setState({days:0, hours:0, minutes:0, seconds: 0});
        window.localStorage.setItem('start_timer', '0');
        if (typeof window.forceUpdateWelcomePage === 'function')
            window.forceUpdateWelcomePage();
    }

    componentWillUnmount() {
        this.stopTimer();
        window.startTimer = window.stopTimer = null;
    }

    formatterDate() {
        let days = this.state.days;
        let hours = this.state.hours;
        let minutes = this.state.minutes;
        let seconds = this.state.seconds;
        let timeDisplay = '';

        if (days) {
            timeDisplay += days+'d ';
        }
        if (days > 0 || hours) {
            timeDisplay += ((hours < 10) ? "0" + hours : hours) + 'H ';
        }
        timeDisplay += ((minutes < 10) ? "0" + minutes : minutes) + 'Mins';

        // if (days === 0 && hours === 0 && minutes === 0) {
            timeDisplay += ' ' + ((seconds < 10) ? "0" + seconds : seconds) + 'Sec';
        // }

        return <span className="timer">{timeDisplay}</span>
    }

    render() {
        return (
            <>
                {
                    this.state.days || this.state.hours || this.state.minutes || this.state.seconds ? (
                        <div className="timer_until_end">
                            Your Hire Ends in:
                            <br/>
                            {this.formatterDate()}
                            <br/>
                            To extend please contact us
                        </div>
                    ) : ('')
                }
            </>
        );
    }
}

export default TimerUntilEnd;